/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('SyncAndShareNode', ['$resource', '$routeParams', 'NodesInterceptor',
        function ($resource, $routeParams, NodesInterceptor) {
            var
                listAttributes = ['uuid', 'name', 'revision', 'is_directory', 'size', 'file_modification_date', 'is_deleted', 'synced',
                    'owner', 'preview_type', 'has_esignature', 'has_revisions', 'has_deleted', 'has_active_links', 'read_only', 'is_shared',
                    'owner_email', 'can_be_streamed', 'type', 'checksum', 'parent_uuid', 'actions', 'permissions', 'office_online_permissions',
                    'latest_notarized_revision', 'folder_share'],
                resource = $resource('/sync_and_share_nodes/:uuid/:action', { uuid: '@uuid' }, {
                    get: { method: 'GET', params: { fields: [...listAttributes, 'parents', 'content_stats'].join(',') }, interceptor: NodesInterceptor, cancellable: true },
                    getChildren: { method: 'GET', params: { action: 'contents' }, isArray: true, interceptor: NodesInterceptor },
                    getContentsSize: { method: 'GET', params: { action: 'contents_size' } },
                    move: { method: 'POST', params: { action: 'move' }, ignoreConflictErrors: true }, // conflicts are handled in `CopyMoveController`
                    copy: { method: 'POST', params: { action: 'copy' }, ignoreConflictErrors: true }, // conflicts are handled in `CopyMoveController`
                    query: { method: 'GET', params: { per_page: 50, uuid: function () { return $routeParams.uuid; }, action: 'contents', fields: listAttributes.join(',') }, isArray: true, interceptor: NodesInterceptor, cancellable: true },
                    search: { method: 'GET', params: { uuid: function () { return $routeParams.uuid || '0'; }, action: 'search', fields: [...listAttributes, 'path'].join(',') }, isArray: true, interceptor: NodesInterceptor, cancellable: true },
                    restore: { method: 'POST', params: { action: 'restore', rename_uuid: '@rename_uuid', rename_to: '@rename_to' } },
                    createPath: {
                        cancellable: true,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        hasBody: false,
                        interceptor: NodesInterceptor,
                        method: 'POST',
                        params: {
                            'sync_and_share_node[path]': '@path',
                        },
                        ignoreConflictErrors: true
                    },
                    sync: {
                        params: { action: 'sync_status' },
                        method: 'POST',
                        transformRequest: function (data) {
                            return angular.toJson({ sync_name: data.syncName });
                        }
                    },
                    unsync: {
                        params: { action: 'sync_status' },
                        method: 'DELETE',
                        transformRequest: function () {
                            return null;
                        }
                    },
                    update: {
                        method: 'PUT'
                    },
                    getPermissions: {
                        method: 'GET',
                        ignoreApiErrors: true,
                        params: { fields: 'permissions' },
                        transformResponse: function (data, _, status) {
                            if (status !== 200) {
                                return {};
                            } else {
                                return angular.fromJson(data)['permissions'];
                            }
                        }
                    }
                });

            resource.prototype.update = function (attributes) {
                return this.$update.call(angular.extend({}, attributes, {uuid: this.uuid}));
            };

            resource.prototype.getParent = function () {
                return this.$get.call({}, { uuid: this.parent_uuid });
            };

            resource.prototype.isSyncAndShareNodeResource = true;

            resource.getDownloadUrl = function (node, revision) {
                return node.actions.download + (revision ? '?revision=' + revision : '');
            };

            resource.getPreviewUrl = function (node) {
                return node.actions.preview;
            };

            resource.getUploadUrl = function (node) {
                return node.actions.upload;
            };

            resource.getEditUuid = function (node) {
                return node.uuid;
            };

            resource.createNode = function (node, successCallback, failureCallback) {
                return resource.save(node, successCallback, failureCallback);
            };

            resource.getNode = function (node, successCallback, failureCallback) {
                return resource.get(node, successCallback, failureCallback);
            };

            return resource;
        }]);
